export const validateEmail = (string) => {
    if (string !== null && string !== undefined) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return !emailRegex.test(string);
    }
  };
  